<app-base-template (modal)="openModal()" [displayData]="displayData"
                   [nextOffset]="nextOffset" [previousOffset]="previousOffset" [totalPage]="totalPage"
                   [dataLoaded]="dataLoaded" [hidePagination]="hidePagination"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Search</div>
    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>


        <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="1" (change)="UserFilter()"> User Filter</mat-radio-button> &nbsp;&nbsp;
            <mat-radio-button value="2" (change)="sGrpFilter()">Support Group Filter</mat-radio-button>
        </mat-radio-group>

        <div *ngIf = "isUserFilter">

        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Analyst Login ID"
                   [(ngModel)]="userSelected"
                   matInput [formControl]="searchUser" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
                <mat-option *ngIf="isLoading" class="is-loading">
                    <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option *ngFor="let user of usrs" [value]="user.login_name">
                        {{ user.name }} - {{user.login_name}}
                    </mat-option>
                </ng-container>
            </mat-autocomplete>
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly
                   [(ngModel)]="userName">
        </div>


      </div>

        <div class="form-group matFrom" *ngIf = "isGrpFilter">
            <mat-form-field>
                <mat-label class="font-13">Select support group</mat-label>
                <mat-select [(ngModel)]="sgroupSelected" multiple>
                    <mat-option *ngFor="let group of support_group" [value]="group.id"
                                class="font-13">{{group.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success float-right radius-0 mar_Right" (click)="search()" *ngIf = "isUserFilter">search</button>
        <button type="button" class="btn btn-primary float-right radius-0 mar_Right" [disabled]="isExportDisable" (click)="exportToExcel()" *ngIf ="isGrpFilter">Export To Excel</button>

        <button type="button" class="btn btn-danger float-right radius-0 " (click)="c()">Cancel</button>
    </div>
</ng-template>
<notifier-container></notifier-container>


